export default __webpack_public_path__ + "static/media/page9Image3.fce0ba63.jpg";